var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showFinnish
      ? _c("table", { staticClass: "table cookie-table" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1)
        ])
      : _c("table", { staticClass: "table cookie-table" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3)
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w-20" }, [_c("strong", [_vm._v("Eväste")])]),
        _vm._v(" "),
        _c("th", { staticClass: "w-75" }, [_c("strong", [_vm._v("Kuvaus")])]),
        _vm._v(" "),
        _c("th", { staticClass: "w-5" }, [
          _c("strong", [_vm._v("Välttämätön?")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tbody", [
      _c("tr", [
        _c("td", [
          _vm._v(
            "\n          www-asiointi-stea-fi.AspNet.SharedCookie\n        "
          )
        ]),
        _vm._v(" "),
        _c("td", [_vm._v("Käytetään käyttäjän tunnistamiseen.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          ASP.NET_SessionId\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Käytetään käyttäjän istunnon tunnistamiseen.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _vm._v(
            "\n          www-asiointi-stea-fi.AspNet.AntiforgeryToken\n        "
          )
        ]),
        _vm._v(" "),
        _c("td", [_vm._v("Käytetään estämään XSRF/CSRF -hyökkäyksiä.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          __RequestVerificationToken\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Käytetään estämään XSRF/CSRF -hyökkäyksiä.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _vm._v(
            "\n          ARRAffinitySameSite\n          ARRAffinity\n        "
          )
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v("Azure-evästeet joita käytetään tietoliikenteen ohjaamiseen.")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          SessionExpires\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Kertoo milloin käyttäjän istunto vanhenee.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          _culture\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Määrittää käyttäjän käyttöliittymän kielen.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          _mconsent\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Käyttäjän eväste-asetuksen arvo.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Kyllä")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _vm._v("\n          _pk_ses.4.1fff"),
          _c("br"),
          _vm._v("\n          _pk_id.4.1fff"),
          _c("br")
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            "Matomo -evästeet joita käytetään verkkopalvelun käytettävyyden ja käytön analysoimiseksi, seurantaan ja palvelun kehittämiseksi."
          )
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ei")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w-20" }, [
          _c("strong", [_vm._v("Kaka (cookie)")])
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "w-75" }, [
          _c("strong", [_vm._v("Beskrivning")])
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "w-5" }, [
          _c("strong", [_vm._v("Nödvändigt?")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tbody", [
      _c("tr", [
        _c("td", [
          _vm._v(
            "\n          www-asiointi-stea-fi.AspNet.SharedCookie\n        "
          )
        ]),
        _vm._v(" "),
        _c("td", [_vm._v("Används för användarens identifiering.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          ASP.NET_SessionId\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Används för identifiering av användarens session.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _vm._v(
            "\n          www-asiointi-stea-fi.AspNet.AntiforgeryToken\n        "
          )
        ]),
        _vm._v(" "),
        _c("td", [_vm._v("Används för att hindra XSRF/CSRF-attacker.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          __RequestVerificationToken\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Används för att hindra XSRF/CSRF-attacker.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _vm._v(
            "\n          ARRAffinitySameSite\n          ARRAffinity\n        "
          )
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v("Azure-kakor som används för datatrafikens styrning.")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          SessionExpires\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Berättar när användarens session går ut.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          _culture\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Fastställer användargränsnittets språk.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("\n          _mconsent\n        ")]),
        _vm._v(" "),
        _c("td", [_vm._v("Användarens kakinställningens värde.")]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Ja")])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _vm._v("\n          _pk_ses.4.1fff"),
          _c("br"),
          _vm._v("\n          _pk_id.4.1fff"),
          _c("br")
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            "Matomo –kakor används för förbättring av användbarheten i webbplatsen, analysering och uppföljning av användningen och tjänstens utveckling."
          )
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "centered" }, [_vm._v("Nej")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }